import React from 'react';

import { MediaEntry, ProductPrice } from 'src/types/global-types';
import { Reviews } from 'src/components/Reviews/reviews.types';
import { ProductLabelsList } from 'src/components/ProductLabels/ProductLabelsList';
import { EnergyRatingLabel } from 'src/components/EnergyRatingLabel/EnergyRatingLabel';

import { ReviewCount } from '../Reviews/ReviewCount';

import { ProductGallery, ProductGalleryProvider } from './ProductGallery';
import { BaseProduct } from './utils/product-detail.types';
import classes from './ProductDetail.scss';

type ProductDetailLayoutProps = {
    beforeReviews?: React.ReactNode;
    energyRating?: null;
    media_entries: MediaEntry[];
    price: ProductPrice | null;
    product: BaseProduct;
    reviews?: Reviews | null;
};

export const ProductDetailLayout: React.FC<ProductDetailLayoutProps> = React.memo((props) => {
    const { media_entries } = props;

    const { name, energy_rating, product_fiche_image, energy_label_image, subTitle } = props.product;

    const hasLabels = props.product.labels.length > 0;
    const hasEnergyRating = energy_rating && energy_rating !== ' ' ? energy_rating : undefined;
    const hasEnergyLabelImage = energy_label_image ?? undefined;

    return (
        <ProductGalleryProvider media_entries={media_entries}>
            <div className={classes.productDetail}>
                <div className={classes.productDetailGallery}>
                    <ProductGallery name={props.product.name} />
                </div>
                <div className={classes.productDetailOptions}>
                    <div className={classes.productDetailHeading}>
                        {hasLabels && (
                            <ProductLabelsList
                                direction="row"
                                className={classes.productListContainer}
                                labels={props.product.labels}
                                locationVariant="detail"
                            />
                        )}

                        <h1 className={classes.title}>{name}</h1>
                        <h3 className={classes.subTitle}>{subTitle}</h3>
                        {props.reviews && (
                            <ReviewCount
                                starCount={props.reviews.average_score}
                                reviewCount={props.reviews.total_reviews}
                                showTotal={true}
                                canWrite={true}
                            />
                        )}

                        {hasEnergyRating && (
                            <EnergyRatingLabel
                                specificationLink={product_fiche_image}
                                energyLabelImage={hasEnergyLabelImage}
                                letter={hasEnergyRating}
                                inProductList={true}
                                variant="pdp"
                            />
                        )}
                    </div>
                    {props.children}
                </div>
            </div>
        </ProductGalleryProvider>
    );
});
